const tileLayoutSections = document.querySelectorAll('.tile_layout_section')
if (tileLayoutSections) {
  Array.prototype.forEach.call(tileLayoutSections, (tileLayoutSection) => {
    const tileCards = tileLayoutSection.querySelectorAll('.tile-card-link-video')
    if (tileCards) {
      Array.prototype.forEach.call(tileCards, (card) => {
        const videoOpen = card.querySelector('.tile-card')
        const videoId = card.querySelector('.video-id-wrapper').getAttribute('data-id')
        const popupWrapper = document.querySelector('.tile-popup-wrapper')
        const iframeWrapper = popupWrapper.querySelector('.iframe-wrapper')
        const iframeElem = document.createElement('iframe')
        let isRan = false
        if (videoOpen) {
          videoOpen.addEventListener('click', () => {
            tileLayoutSection.classList.add('popup-open')
            popupWrapper.appendChild(iframeWrapper)
            popupWrapper.classList.add('open')
            iframeElem.setAttribute('width', '560')
            iframeElem.setAttribute('height', '315')
            iframeElem.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`)
            iframeElem.setAttribute('title', 'YouTube video player')
            iframeElem.setAttribute('frameborder', '0')
            iframeElem.setAttribute('autoplay', '1')
            iframeElem.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture')
            iframeElem.setAttribute('allowfullscreen', '')
        
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/player_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            var player;
            function onYouTubePlayerAPIReady() {
              player = new YT.Player('.video-popup-frame', {
                height: '360',
                width: '640',
                videoId: videoId,
                autoplay: 1
              });
            }
            //if (!isRan) {
              iframeWrapper.appendChild(iframeElem)
            //}
            isRan = true
          })
          popupWrapper.addEventListener('click', (e) => {
            if (e.target !== popupWrapper.querySelector('iframe')) {
              popupWrapper.classList.remove('open')
              iframeWrapper.innerHTML = ''
              iframeWrapper.remove()
              if (popupWrapper.querySelector('iframe')) {
                popupWrapper.querySelector('iframe').remove()
              }
              tileLayoutSection.classList.remove('popup-open')
            }
          })
        }
      })
    }
  })
}